import { httpRequest } from "@services/http";
import { JourneyPath } from "@models/journeyPath.model";

export class CommandDeleteJourneyPath {
  async run(contractId: number, pricesheetId: number, pathId: number): Promise<JourneyPath> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/finance/contracts/${contractId}/pricesheets/${pricesheetId}/journey-paths/${pathId}/`;
    const response = await httpRequest<any>(url, { method: "DELETE" });
    return new JourneyPath(response);
  }
}
